/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
import { ECSConfigKey, ECSConfigService } from "sh-services";

import { MemberRequest } from "../MemberRequest/MemberRequest";

import { MemberRequestListProps } from "./MemberRequestListProps";

/**
 * Renders the Requests list.
 * @param props The props for the component.
 * @returns A list of requests.
 */
export const MemberRequestList: React.FC<MemberRequestListProps> = props => {
    // Split the props into the requestList and the rest of the props.
    const { requestList, ...memberRequestProps } = props;
    const isToggleCheckboxVisibilityEnabled = ECSConfigService.isECSFeatureEnabled(ECSConfigKey.ToggleCheckboxVisibilityEnabled);

    return (
        <>
            {requestList.map(memberRequest => {
                const key = memberRequest.request.id;
                return <MemberRequest key={key} request={memberRequest} {...memberRequestProps} { ...(isToggleCheckboxVisibilityEnabled && { requestCount: requestList.length }) }/>;
            })}
        </>
    );
};
